export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M2 2v20h20V2H2zm9 2H4v16h7V4zm2 16h7V4h-7v16z" } }, { "tag": "path", "att": { "d": "M9 13c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1zm6 0c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1z" } }];
export const iconName = 'double-doors';
export const doubleDoors = { iconName, paths };
export default paths;
